var _defs, _path, _path2, _path3, _path4, _path5, _use, _use2, _use3, _use4, _use5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icon-css-tf",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#fff",
    d: "M0-21l12.3 38L-20-6.5h40L-12.3 17z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002395",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h292.8v196.8H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002395",
    d: "M0 0h96v192H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    d: "M192 0h96v192h-96z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426 219.6l15.4 24.6h44V330l-33-51.6-44.4 70.8h21.6l22.8-40.8 46.8 84 46.8-84 22.8 40.8h21.6L546 278.4 513 330v-47.4h19.8l14.7-23.4H513v-15h44l15.4-24.6H426zm51.6 105h-48v16.8h48zm91.2 0h-48v16.8h48z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 416,
    y: 362,
    transform: "scale(1.2)",
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 371,
    y: 328,
    transform: "scale(1.2)",
    xlinkHref: "#a"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 461,
    y: 328,
    transform: "scale(1.2)",
    xlinkHref: "#a"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 333,
    y: 227,
    transform: "scale(1.2)",
    xlinkHref: "#a"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 499,
    y: 227,
    transform: "scale(1.2)",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTf);
export default __webpack_public_path__ + "static/media/tf.cf4959c4339d5b1230931b8b44c5e9a9.svg";
export { ForwardRef as ReactComponent };